import { Col, Image, Row } from "react-bootstrap";
import { ASSETS } from "assets";
import AuthenticationForm from "lib/components/authentication/authentication-form";
import FlexBox from "lib/components/common/flex-box";
import Hyperlink from "lib/components/common/hyperlink";
import AuthenticationLayout from "lib/components/layouts/authentication";
import { DEFAULT_APP_VAR } from "lib/constants";
import { PAGE_ROUTES } from "lib/constants/page-routes";
import { AppContext } from "lib/contexts/app-context";
import { useContext, useEffect } from "react";


const SignOut: React.FC = () => {
  const { updateAppState } = useContext(AppContext);

  useEffect(() => {
    updateAppState(DEFAULT_APP_VAR);
  }, []);

  return (
    <AuthenticationLayout>
      <Row className="vh-100" justifyContent="around">
        <Col
          lg={8}
          className="d-none d-lg-flex align-items-center justify-content-center"
        >
          <Image
            src={ASSETS.IMAGES.LOGIN_IMAGE}
            alt="Sign In"
            className="login-image"
          />
        </Col>
        <Col lg={4} md={12} className="d-flex align-items-center px-4">
          <AuthenticationForm className="w-100 px-4">
            <FlexBox justifyContent="start" className="mb-4 mx-2">
              <h2>Signout</h2>
            </FlexBox>
            <p>
              You are signed out of your current session. All your data is safe.
              <br />
              <br />
              To login again use the Login link below.
            </p>
            <br />
            <p className="text-center px-4 mt-2">
              Want to login again?{" "}
              <Hyperlink to={PAGE_ROUTES.AUTHENTICATION.Login}>Sign In</Hyperlink>
            </p>
          </AuthenticationForm>
        </Col>
      </Row>
    </AuthenticationLayout>
  );
};

export default SignOut;
